// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","fontNormal":"_2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","loading":"_3s6Sw2_bEfrlB2-Z6i_h9n _2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","fade-in-out":"_2p9I4MIm32pPKLwi40vcgT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/grid/grid.css
// module id = 936
// module chunks = 0